import type { DriveStep } from "driver.js";
import { ONBOARDING_IDS } from "../constants";

export const leaderboardsSteps: DriveStep[] = [
    {
        element: `#${ONBOARDING_IDS.LEADERBOARDS_NAV}`,
        popover: {
            title: "Leaderboard Views",
            description:
                "Switch between three perspectives: " +
                "Top Match Performances ranks players across all matches by default — you can narrow it to any number of specific games using the match selector. " +
                "Tournament Champions aggregates results across a full tournament, " +
                "and Season Leaders spans the entire season.",
            side: "bottom",
            align: "start",
        },
    },
    {
        element: `#${ONBOARDING_IDS.LEADERBOARDS_CONTEXT_SELECTOR}`,
        popover: {
            title: "Scope Selector",
            description:
                "This changes depending on the active view. " +
                "In Top Match Performances, pick specific matches to include — leave it empty to rank across all matches. " +
                "In Tournament Champions, select a specific tournament. " +
                "In Season Leaders, choose the season year. " +
                "The table updates instantly as you change the scope.",
            side: "bottom",
            align: "end",
        },
    },
    {
        element: `#${ONBOARDING_IDS.LEADERBOARDS_TABLE}`,
        popover: {
            title: "Rankings Tables",
            description:
                "The tables rank players by metrics: Total KPI,Average KPI Per Match, Goals, Assists, or Blocked Shots. " +
                "Top 3 spots get trophy and medal icons. Each row shows the player's name — click it to jump straight to their profile — " +
                "along with their tournament, matches played, and the metric value colour-coded by KPI tier. " +
                "Click any column header to re-sort the table by that column.",
            side: "top",
            align: "center",
        },
    },
];
